import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1d076c00")

_pushScopeId("data-v-1d076c00")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Riepilogo presenze")
const _hoisted_2 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "page_content"
}
const _hoisted_4 = { class: "presenze_switcher_container" }
const _hoisted_5 = { class: "presenze_switcher" }
const _hoisted_6 = {
  key: 0,
  class: "month_selector_container"
}
const _hoisted_7 = { class: "month_selector" }
const _hoisted_8 = { class: "search_container" }
const _hoisted_9 = {
  key: 1,
  class: "no_presenze_container"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "no_presenze" }, "Nessuna presenza da visualizzare", -1)
const _hoisted_11 = {
  key: 2,
  class: "container_presenze"
}
const _hoisted_12 = { class: "section_title" }
const _hoisted_13 = { class: "presenza_sx" }
const _hoisted_14 = { class: "icon" }
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "data" }
const _hoisted_17 = { class: "orari" }
const _hoisted_18 = { class: "value" }
const _hoisted_19 = {
  key: 0,
  class: "anomalia"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_input = _resolveComponent("ion-input")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu())),
                slot: "start"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.loadPresenze()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: $setup.refresh,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          ($setup.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "dark"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, [
                    _createVNode("div", {
                      class: ["type", [$setup.selectedPeriod == 'oggi' ? 'active' : '']],
                      onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.setActivePeriod('oggi')))
                    }, " Oggi ", 2),
                    _createVNode("div", {
                      class: ["type", [$setup.selectedPeriod == 'settimana' ? 'active' : '']],
                      onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.setActivePeriod('settimana')))
                    }, " Settimana ", 2),
                    _createVNode("div", {
                      class: ["type", [$setup.selectedPeriod == 'mese' ? 'active' : '']],
                      onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.setActivePeriod('mese')))
                    }, " Mese ", 2)
                  ])
                ]),
                ($setup.selectedPeriod === 'mese')
                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                      _createVNode("div", _hoisted_7, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.months, (month, index) => {
                          return (_openBlock(), _createBlock("div", {
                            key: index,
                            class: ["month_badge", [
                                $setup.selectedMonth === month.value ? 'active' : '',
                                month.disabled ? 'disabled' : ''
                            ]],
                            onClick: ($event: any) => (!month.disabled && $setup.setActiveMonth(month.value))
                          }, _toDisplayString(month.label), 11, ["onClick"]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_8, [
                  _createVNode(_component_ion_input, {
                    type: "text",
                    "clear-input": "",
                    modelValue: $setup.searchQuery,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ($setup.searchQuery = $event)),
                    placeholder: "Cerca per nome dipendente",
                    class: "search_presenze_input"
                  }, null, 8, ["modelValue"])
                ]),
                ($setup.presenzeToShow.length == 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_9, [
                      _hoisted_10
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_11, [
                      _createVNode("div", _hoisted_12, "Presenze dipendenti - " + _toDisplayString($setup.getPeriodLabel()), 1),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.presenzeToShow, (presenza) => {
                        return (_openBlock(), _createBlock("div", {
                          key: presenza.presenze_id,
                          class: "presenza"
                        }, [
                          _createVNode("div", _hoisted_13, [
                            _createVNode("div", _hoisted_14, [
                              (presenza.presenze_ora_inizio && presenza.presenze_ora_fine)
                                ? (_openBlock(), _createBlock(_component_ion_icon, {
                                    key: 0,
                                    icon: $setup.arrowBackCircle
                                  }, null, 8, ["icon"]))
                                : (_openBlock(), _createBlock(_component_ion_icon, {
                                    key: 1,
                                    icon: $setup.arrowForwardCircle
                                  }, null, 8, ["icon"]))
                            ]),
                            _createVNode("div", null, [
                              _createVNode("div", _hoisted_15, _toDisplayString(presenza.dipendenti_nome) + " " + _toDisplayString(presenza.dipendenti_cognome), 1),
                              _createVNode("div", _hoisted_16, [
                                _createTextVNode(_toDisplayString($setup.dateFormat(presenza.presenze_data_inizio)) + " ", 1),
                                _createVNode("span", null, "Ore: " + _toDisplayString(presenza.presenze_ore_totali), 1)
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_17, [
                            _createVNode("span", _hoisted_18, _toDisplayString(presenza.presenze_ora_inizio) + " " + _toDisplayString(presenza.presenze_ora_fine ? " - " + presenza.presenze_ora_fine : ""), 1),
                            (presenza.presenze_anomalia == 1)
                              ? (_openBlock(), _createBlock("span", _hoisted_19, " Anomalia "))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ]))
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})